import { gql } from "@apollo/client";

export const CLAIM_REWARD = gql`
  mutation RewardsClaim($productId: String) {
    rewardsClaim(productId: $productId)
  }
`;